import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip, } from "antd";
import InputForm from "./InputForm";
import axios from "axios";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import "./Form.css";
import "../pages/Pages.css";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import { getUsuario } from "../utils/LoginManager";
import TituloParcelaForm from './TituloParcelaForm';
import NotaFiscalEmissaoComplForm from './NotaFiscalEmissaoComplForm';
import SpinnerForm from './SpinnerForm';

const { Column } = Table;

export const OPCOES_COMBO_PARC = [
  {
    key: 'A',
    label: 'ABERTO'
  },
  {
    key: 'P',
    label: 'PAGO'
  },
]

export const OPCOES_COMBO_TIPO_VENDA = [
  {
    key: 'V',
    label: 'VENDA'
  },
  {
    key: 'C',
    label: 'CONDICIONAL'
  },
]


export default class VendaBalcaoForm extends Component {
  state = {
    registro: {
      ven_idf: 0,
      ven_numero: '',
      ven_dt_venda: moment().format('DD/MM/YYYY'),
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_acres: 0,
      ven_vlr_desc: 0,
      ven_vlr_total: 0,
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_tipo_doc: { key: '0' },
      ven_cond_pagto: { key: '0' },
      ven_tipo_venda: { key: 'V' },
      ven_emitir_nfe: 0,
    },

    registroNfe: {},
    modalEmissaoNFeVisible: false,
    modalParcelaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,
    condicional: false,

    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,

  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }

      this.setState({
        registro: this.props.registroSelecionado.dados,
        ven_pessoa: this.props.registroSelecionado.dados.ven_pessoa,
        ven_usuario: this.props.registroSelecionado.dados.ven_usuario,
        ven_tipo_doc: this.props.registroSelecionado.dados.ven_tipo_doc,
        ven_cond_pagto: this.props.registroSelecionado.dados.ven_cond_pagto,
        listaProdutos: this.props.registroSelecionado.dados.listaProdutos ? this.props.registroSelecionado.dados.listaProdutos : [],
        listaParcelas: this.props.registroSelecionado.dados.listaParcelas ? this.props.registroSelecionado.dados.listaParcelas : [],
        caixaFechado,
        visualizando: this.props.registroSelecionado.dados.visualizando,
        condicional: this.props.registroSelecionado.dados.ven_pessoa && this.props.registroSelecionado.dados.ven_pessoa.key !== '' && this.props.registroSelecionado.dados.ven_pessoa.key !== '0' ? true : false,
        editando: false,
        mi_seq: 0,
        mi_item: { key: '' },
        prod_codigo: '',
        prod_descricao: '',
        prod_cod_barras: '',
        mi_qtde: 1,
        mi_vlr_unit: 0,
        mi_vlr_Custo: 0,
        mi_perc_desc: 0,
        mi_vlr_desc: 0,
        mi_vlr_acres: 0,
        mi_vlr_total: 0,
      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }



  onOK = () => {

    if ((!this.state.registro.ven_pessoa) || (this.state.registro.ven_pessoa.key === '0') || (this.state.registro.ven_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }

    if ((!this.state.registro.ven_usuario) || (this.state.registro.ven_usuario.key === '0') || (this.state.registro.ven_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }

    if (this.state.registro.ven_tipo_venda.key === 'V') {
      if ((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) {
        let vlrTotalParc = 0
        for (var x in this.state.listaParcelas) {
          vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
        };
        let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
        if (vlrDifParc !== 0) {
          Modal.warning({ title: 'Aviso!', content: 'O Valor Total da Venda não Confere com o Valor Total das parcelas', });
          return;
        }
      } else {
        Modal.warning({ title: 'Aviso!', content: 'Informe alguma Parcela', });
        return;
      }
    }



    if (this.state.ven_emitir_nfe) {
      Modal.confirm({
        title: 'Confirmação de Emissão',
        content: `Deseja Emitir NFe desta venda?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => { this.onAbrirModalEmissaoNFeClick() }
      })
    } else {
      this.onSalvar();
    }
  };

  onSalvar = (reg) => {

    // console.log('VendaBalcaoForm.onSalvar', reg)

    let registro = [];
    if (this.state.registro.ven_tipo_venda.key === 'V') {

      registro = {
        ven_idf: this.state.registro.ven_idf,
        venc_idf: 0,
        ven_dt_venda: moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        ven_numero: this.state.registro.ven_numero,
        ven_pessoa: this.state.ven_pessoa.key,
        pes_nome: this.state.ven_pessoa.label,
        ven_usuario: this.state.ven_usuario.key,
        ven_tipo_doc: this.state.registro.ven_tipo_doc.key,
        ven_cond_pagto: this.state.registro.ven_cond_pagto.key,
        ven_vlr_itens: this.state.registro.ven_vlr_itens,
        ven_vlr_desc: this.state.registro.ven_vlr_desc,
        ven_vlr_acres: this.state.registro.ven_vlr_acres,
        ven_vlr_total: this.state.registro.ven_vlr_total,
        ven_obs: this.state.registro.ven_obs,
        ven_tipo_venda: this.state.registro.ven_tipo_venda.key,
        condicional: this.state.condicional,
        ven_emitir_nfe: this.state.registro.ven_emitir_nfe ? this.state.registro.ven_emitir_nfe : '0',

        listaProdutos: this.state.listaProdutos,
        listaParcelas: this.state.listaParcelas,

        registroNfe: reg,
      };

    } else {

      registro = {
        venc_idf: this.state.registro.ven_idf,
        venc_dt_venda: moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        venc_numero: this.state.registro.ven_numero,
        venc_pessoa: this.state.ven_pessoa.key,
        pesc_nome: this.state.ven_pessoa.label,
        venc_usuario: this.state.ven_usuario.key,
        venc_vlr_itens: this.state.registro.ven_vlr_itens,
        venc_vlr_desc: this.state.registro.ven_vlr_desc,
        venc_vlr_acres: this.state.registro.ven_vlr_acres,
        venc_vlr_total: this.state.registro.ven_vlr_total,
        venc_obs: this.state.registro.ven_obs,
        ven_tipo_venda: this.state.registro.ven_tipo_venda.key,

        listaProdutos: this.state.listaProdutos,
      };

    }

    this.props.onSalvarClick(registro);
  }


  // ----------------------------------------------------------------
  // EMISSÃO NFE
  // ----------------------------------------------------------------

  onAbrirModalEmissaoNFeClick = () => {
    // console.log('onAbrirModalEmissaoNFeClick', this.state.registro);

    this.setState({
      modalEmissaoNFeVisible: true,
      registroNfe: {
        registro: {
          dados: {
            nf_destinatario: {
              key: String(this.state.registro.ven_pessoa.key),
              label: this.state.registro.ven_pessoa.label,
            },
            nf_idf: 0,
            nf_tipo: 'Venda',
            nf_numero: '0',
            nf_serie: '0',
            situacao_nota: 'Nova NFe',
            nf_dt_inclusao: moment().format('DD/MM/YYYY'),
            nf_dt_emissao: moment().format('DD/MM/YYYY'),
            nf_forma_pagamento: { key: '2', label: '', },
            nf_finalidade_emissao: { key: '1', label: '', },
            nf_consumidor_final: { key: '1', label: '', },
            nf_tipo_documento: { key: '1', label: '', },
            nf_tipo_atendimento: { key: '1', label: '', },
            nff_tipo: { key: '9', label: '', },

            nff_idf_transportadora: { key: '0', label: '', },
            nff_especie: 0,
            nff_marca: 0,
            nff_num_volumes: 0,
            nff_peso_bruto: 0,
            nff_peso_liquido: 0,
            nff_qtde_vol: 0,

          }
        },
        registroVenda: this.state.registro,
        listaProdutosNF: [],
        listaProdutosVenda: this.state.listaProdutos
      },
    })
  }

  onFecharModalEmissaoNFeClick = () => {
    this.setState({
      modalEmissaoNFeVisible: false,
    });
  }

  onSalvarEmissaoNfeClick = (registroNfe) => {
    this.setState({
      modalEmissaoNFeVisible: false,
    },
      this.onSalvar(registroNfe)
    );
  }

  // ----------------------------------------------------------------




  onChangeTipoVendas = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  };




  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.ven_tipo_doc) || (this.state.registro.ven_tipo_doc.key === '0') || (this.state.registro.ven_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
      return;
    }

    if ((!this.state.registro.ven_cond_pagto) || (this.state.registro.ven_cond_pagto.key === '0') || (this.state.registro.ven_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento' });
      return;
    }

    if (parseFloat(this.state.registro.ven_vlr_total) > 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.ven_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.ven_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.ven_vlr_total) / w_Qtde_Parc).toFixed(2);

      // console.log('w_cc: ', w_cc);
      // console.log('w_Qtde_Parc: ', w_Qtde_Parc);
      // console.log('w_Parc_AVista: ', w_Parc_AVista);
      // console.log('w_Data_Emissao: ', w_Data_Emissao);
      // console.log('w_Data_Parc: ', w_Data_Parc);

      if (w_Parc_AVista) {
        // w_Data_Pgto = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Data_Parc = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      // console.log('w_Sit: ', w_Sit);
      // console.log('w_Data_Pgto: ', w_Data_Pgto);

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        // console.log('w_Data_Parc: ', iParc + ' - ' + w_Data_Parc);

        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.ven_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.ven_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        // console.log('ven_vlr_total: ', this.state.registro.ven_vlr_total);
        // console.log('vlrTotalParc: ', vlrTotalParc);

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.ven_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
          // console.log('vlrDif: ', vlrDif);

          vlrDif = vlrDif * (-1);
          // console.log('vlrDif: ', vlrDif);
          // console.log('w_Sit: ', listaNova[0].tparc_situacao);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }

    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.ven_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['ven_tipo_doc'] = event.ven_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['ven_cond_pagto'] = event.ven_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ven_pessoa'] = event.ven_pessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['ven_usuario'] = event.ven_usuario;
    this.setState(event);
  }


  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };






  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharClick, carregando, visivel } = this.props;
    const { usuario, caixaFechado, condicional, vlrDifParc, vlrTotalParc, carregandoForm, listaParcelas,
      modalParcelaVisible, modalEmissaoNFeVisible, registroNfe, listaProdutos, ven_emitir_nfe } = this.state;
    const { ven_pessoa, ven_cond_pagto, ven_tipo_doc, ven_vlr_total, ven_usuario, ven_tipo_venda } = this.state.registro;

    // console.log('VendaBalcaoForm.this.props', this.props);
    // console.log('VendaBalcaoForm.this.state', this.state);

    return (
      <Modal
        title={"Finalizar Venda"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={ven_vlr_total}
          condPagto={ven_cond_pagto}
        />

        <NotaFiscalEmissaoComplForm
          visivel={modalEmissaoNFeVisible}
          onSalvarEmissaoNfeClick={this.onSalvarEmissaoNfeClick}
          onFecharModalEmissaoNFeClick={this.onFecharModalEmissaoNFeClick}
          registroNfe={registroNfe}
          listaProdutos={listaProdutos}
        />

        <SpinnerForm visivel={carregando} texto={'Transmitindo Nota. Aguarde...'} />

        <div>
          <Row>
            <Row>
              <Col xs={24} sm={5} style={{ marginTop: -10, marginRight: 10 }}>
                <span>Tipo</span>
                <InputForm
                  type="select"
                  id="ven_tipo_venda"
                  ref="ven_tipo_venda"
                  value={ven_tipo_venda}
                  placeholder="Selecione"
                  onChange={this.onChangeTipoVendas}
                  data={OPCOES_COMBO_TIPO_VENDA}
                  validator={value => Boolean(value)}
                  style={{ width: "100%" }}
                  disabled={condicional ? true : false}
                />
              </Col>

              <Col xs={24} sm={10} style={{ marginTop: -10, marginRight: 10 }}>
                <PessoaFrame
                  label="Cliente"
                  id="ven_pessoa"
                  value={ven_pessoa}
                  tipo="C"
                  width={"100%"}
                  onChange={this.onChangePessoa}
                  disabled={caixaFechado || condicional}
                  descricaoPrimeiroItem="Selecione um Cliente"
                />
              </Col>

              <Col xs={24} sm={8} style={{ marginTop: -10 }}>
                <UsuarioFrame
                  label="Vendedor"
                  id="ven_usuario"
                  value={ven_usuario}
                  width={"105%"}
                  vendedor={1}
                  onChange={this.onChangeVendedor}
                  descricaoPrimeiroItem="Selecione um Vendedor"
                />
              </Col>
            </Row>


            {ven_tipo_venda.key === 'C' ? null : (
              <div style={{ height: "100%" }}>
                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: -10 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="ven_tipo_doc"
                          value={ven_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: -10 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="ven_cond_pagto"
                          value={ven_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <div>
                      <div className="divider-form" />
                      <Row style={{ marginLeft: 30, marginBottom: 10, }}>
                        <Col xs={24}>
                          <Col xs={24} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                            <span>{this.renderValor(ven_vlr_total)}</span>
                          </Col>
                          <Col xs={24} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                            <span>{this.renderValor(vlrTotalParc)}</span>
                          </Col>
                          <Col xs={24} sm={6}>
                            <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                            <span>{this.renderValor(vlrDifParc)}</span>
                          </Col>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {usuario && (usuario.emissorNFe || usuario.emissorNFCe) ? (
                    <Col xs={24} sm={6}>
                      <InputForm
                        type="checkbox"
                        id="ven_emitir_nfe"
                        ref="ven_emitir_nfe"
                        onChange={this.onChange}
                        value={ven_emitir_nfe ? true : false}
                      >
                        Emite NFe
                      </InputForm>
                    </Col>
                  ) : null}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                      {this.state.visualizando || caixaFechado ? null : (
                        <Column
                          key="acoes"
                          title=""
                          render={this.renderAcoesParcelas}
                          width={40}
                          align="center"
                          className="listaCadastro"
                        />
                      )}
                    </Table>
                  </div>
                </Row>

              </div>
            )}

          </Row>

          <Row style={{ marginBottom: 30, marginTop: 50 }}>
            <div className="divider-form" />
            <Col xs={24}>
              <Button
                type="primary"
                htmlType="button"
                loading={carregando}
                onClick={this.onOK}
                className="btn-salvar"
              >
                Salvar Venda
              </Button>
              <Button
                htmlType="button"
                onClick={onFecharClick}
                className="btn-fechar"
              >
                Fechar
              </Button>
            </Col>
          </Row>
        </div>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendaBalcaoForm.js